jQuery(function ($) {
  /* スライダー */
  $('.top-image').slick({
    prevArrow: '<div class="arrow arrow-prev"><i class="fas fa-chevron-left"></i></div>',
    nextArrow: '<div class="arrow arrow-next"><i class="fas fa-chevron-right"></i></div>',
    pauseOnHover: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  /* ナビゲーションのリンクを押したとき */
  $('.jump').each(function () {
    $(this).on('click', function () {
      // href属性を取得
      var href = $(this).attr('href');
      // hrefに'#'を含む場合の処理
      if (href.indexOf('#') != -1) {
        href = href.replace('/', ''); // hrefの'/'を削除
        smoothScroll(href); // スクロールさせる(main.jsを参照)
      }
    });
  });

  /* スマホのメニュー内の要素をクリックした時 */
  $('.spg-item').each(function () {
    $(this).on('click', function () {
      // href属性を取得
      var href = $(this).attr('href');
      // hrefに'#'を含む場合の処理
      if (href.indexOf('#') != -1) {
        href = href.replace('/', ''); // hrefの'/'を削除
        drawer.toggleMenu(); // メニューを閉じる(drawer.jsとdrawer-start.jsを参照)
        smoothScroll(href); // スクロールさせる(main.jsを参照)
      }
    });
  });

  /* よくある質問 */
  $('.quession').each(function () {
    $(this).click(function () {
      $(this).parent().toggleClass('qa-open').find('.answer').slideToggle(250);
      return false;
    });
  });

  /* エントリーのやつ */
  $(window).on('load', function () {
    setTimeout(function () {
      $('.entry-link').addClass('runup');
    }, 500);
  });
});
